import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog } from 'components';
import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import {
	saveCurrentAgencyChanges,
	startupEditAgencyModal,
} from 'features/views/settings/marketPlaceAgencies/editAgencyModal/actions';
import { dialogs } from 'features/views/settings/marketPlaceAgencies/editAgencyModal/constants';
import formDescriptorFn, {
	EDIT_AGENCY_MODAL_FORM_NAME,
} from 'features/views/settings/marketPlaceAgencies/editAgencyModal/form';

import ManagersList from './components/ManagersList';
import UserFilter from './components/UserFilter';

export const EditAgencyModalBody = ({ agency }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(startupEditAgencyModal({ agency }));
	}, [dispatch, agency]);

	const handleContinue = useCallback(() => {
		dispatch(saveCurrentAgencyChanges({ agency }));
	}, [dispatch, agency]);

	return (
		<Form name={EDIT_AGENCY_MODAL_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Stack sx={{ mb: 1 }}>
				<SubmitFormDialog pageName={EDIT_AGENCY_MODAL_FORM_NAME} />
				<Dialog mui name={dialogs.NON_UNIQUE_OR_NON_EXISTANT_USER}>
					{getLabelMessage('settings:editAgencyModal.nonUniqueOrNonExistantUser')}
				</Dialog>
			</Stack>
			<Grid container spacing={3}>
				<Grid size={12}>
					<UserFilter agency={agency} />
				</Grid>
				<Grid size={12}>
					<ManagersList agency={agency} />
				</Grid>
				<Grid size={12}>
					<Grid container justifyContent="center">
						<Grid size={4}>
							<Button variant="contained" onClick={handleContinue} fullWidth>
								{getLabelMessage('common:continue')}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Form>
	);
};

EditAgencyModalBody.propTypes = {
	agency: PropTypes.object,
};

export default EditAgencyModalBody;
